import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { DataContext } from '../context/data';

export const Coffre = () => {

    const { token, identifiantCR, isLoaded } = useContext(DataContext)

    const [isLoadedCoffre, setIsLoadedCoffre] = useState(false);
    const [data, setData] = useState(null)

    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiIsImtpZCI6IjI4YTMxOGY3LTAwMDAtYTFlYi03ZmExLTJjNzQzM2M2Y2NhNSJ9.eyJpc3MiOiJzdXBlcmNlbGwiLCJhdWQiOiJzdXBlcmNlbGw6Z2FtZWFwaSIsImp0aSI6IjhlYjk0NTZiLWI0N2YtNDZlZi05ZDAxLTgyMjQ2MTc3Yjg5OCIsImlhdCI6MTY0NDE3NDg5NCwic3ViIjoiZGV2ZWxvcGVyLzZjY2I3ODY4LWIwOTEtZDM5OC04ZWNjLTBkMDlmZWRhZjkwMiIsInNjb3BlcyI6WyJyb3lhbGUiXSwibGltaXRzIjpbeyJ0aWVyIjoiZGV2ZWxvcGVyL3NpbHZlciIsInR5cGUiOiJ0aHJvdHRsaW5nIn0seyJjaWRycyI6WyIxMjguMTI4LjEyOC4xMjgiXSwidHlwZSI6ImNsaWVudCJ9XX0.6G7ttw6XVe-XtvIoM9EgWNqfWEVtnLc5fw2XscHJgTt81FaS7N1g9JYY1CxoG0NVn6XWHL8gengP-HyS6R-PLg'
    const url = 'https://proxy.royaleapi.dev/v1/players/%23'

    function GetCoffre() {
        useEffect(() => {
            axios.get(url + identifiantCR + '/upcomingchests', { headers: { 'Authorization': `Bearer ${token}` } }).then(res => {
                // console.log(res.data);
                setData(res.data.items);
                setIsLoadedCoffre(true);
                console.log(data);
            })
        }, [])
    }

    if (isLoaded) {
        GetCoffre();


        if (isLoadedCoffre) {

            return (
                <div className='row'>
                    {data.map(coffre => {
                        return (
                            <div className="card col s4 l1" key={coffre.index}>
                                <div className="card-image">
                                    <img className='circle responsive-img' src='img/tournois-clash-royale.png' alt='imgCarte' />
                                    <span className="card-title textBlack">{coffre.name}</span>
                                </div>
                                <div className="card-content">
                                    <p>{coffre.index}</p>
                                </div>
                            </div>

                        )
                    })}
                </div>
            );
        }
        else {
            return (
                <div>
                    <div className="preloader-wrapper big active">
                        <div className="spinner-layer spinner-blue-only">
                            <div className="circle-clipper left">
                                <div className="circle"></div>
                            </div><div className="gap-patch">
                                <div className="circle"></div>
                            </div><div className="circle-clipper right">
                                <div className="circle"></div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    } else {
        return (
            <div>
                <Navigate replace to='/' />
            </div>
        )
    }
};
